/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu-close': {
    width: 42,
    height: 42,
    viewBox: '0 0 42 42',
    data: '<path pid="0" d="M21.068 18.642l7.288-7.288c.429-.429 1.092-.46 1.483-.069.39.39.36 1.054-.068 1.483l-7.288 7.288-1.551 1.55-7.288 7.289c-.429.428-1.092.459-1.483.068-.39-.39-.36-1.054.068-1.483l7.289-7.288 1.55-1.55z" _fill="#FFD300"/><path pid="1" d="M22.482 20.192l7.288 7.289c.429.428.46 1.092.069 1.482-.39.39-1.054.36-1.483-.068l-7.288-7.288-1.55-1.55-7.289-7.29c-.428-.427-.458-1.091-.068-1.481.39-.391 1.054-.36 1.482.068l7.289 7.288 1.55 1.55z" _fill="#FFD300"/>'
  }
})
